import Swiper from "swiper";
import { Autoplay, Pagination } from "swiper/modules";

const DEBUG = true;

const logger = {
  info(message, payload) {
    if (typeof window === "undefined") return;
    if (window.__ZIGGY_DEBUG__ !== true) return;
    if (!DEBUG) return;
    console.info(`[BackgroundImageSlider] ${message}`, payload ?? "");
  },
};

function initBackgroundImageSliders(root = document) {
  root.querySelectorAll("[data-story-slider]").forEach(initOne);
}

function initOne(wrapper) {
  if (wrapper._storySwiper) return;

  const swiperEl = wrapper.querySelector(".swiper");
  if (!swiperEl) return;

  logger.info("init");

  wrapper._storySwiper = new Swiper(swiperEl, {
    modules: [Autoplay, Pagination],
    loop: true,
    grabCursor: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: true,
    },
    pagination: {
      el: wrapper.querySelector(".swiper-pagination"),
      clickable: true,
    },
  });
}

initBackgroundImageSliders();
